(function () {
  'use strict';

  function initTabs(root) {
    root.querySelectorAll('[data-va-tabs]').forEach(function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-va-tab]'));
      var panels = Array.prototype.slice.call(group.querySelectorAll('[data-va-panel]'));

      function activate(tab, moveFocus) {
        var panelId = tab.getAttribute('aria-controls');
        tabs.forEach(function (item) {
          var selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.setAttribute('tabindex', selected ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          var selected = panel.id === panelId;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
        if (moveFocus) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(tab, false); });
        tab.addEventListener('keydown', function (event) {
          var nextIndex;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (typeof nextIndex === 'number') {
            event.preventDefault();
            activate(tabs[nextIndex], true);
          }
        });
      });
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('[data-va-reveal]');
    if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('va-motion-ready');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });
    items.forEach(function (item) { observer.observe(item); });
  }

  function init(root) {
    if (!root || root.dataset.vaReady === 'true') return;
    root.dataset.vaReady = 'true';
    initTabs(root);
    initReveal(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-velvet-about]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
